import { severityMeta, sourceLabel, stageMeta } from './remedialMeta'

const RISKY_PREFIX = /^[=+\-@\t\r]/

const cell = value => {
  if (value === null || value === undefined) return ''
  let text = String(value)
  if (RISKY_PREFIX.test(text)) text = `'${text}`
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export const remedialsCsv = actions => {
  const header = ['Title', 'Severity', 'Stage', 'Source', 'Building Passport', 'Due date', 'Owner', 'Tasks done', 'Created']
  const rows = actions.map(action => [
    action.title,
    severityMeta(action.severity).label,
    stageMeta(action.stage, action).label,
    sourceLabel(action.source),
    action.buildingPassport?.name || '',
    action.effectiveDueDate || action.dueDate || '',
    action.owner?.name || '',
    action.taskSummary?.count ? `${action.taskSummary.completed} of ${action.taskSummary.count}` : '',
    (action.createdAt || '').slice(0, 10),
  ])
  return [header, ...rows].map(row => row.map(cell).join(',')).join('\r\n')
}

export const exportRemedialsCsv = actions => {
  const blob = new Blob([`﻿${remedialsCsv(actions)}`], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `remedials-${new Date().toISOString().slice(0, 10)}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
